<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <modelo-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import ModeloProvider from "../../../providers/ModeloProvider";
    
    import {CrudCreate} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    
    import ModeloForm from "../ModeloForm";
    
    


    export default {
        name: "ModeloCreate",
         
        components: { ModeloForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'modelo.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    nombre: '',
                    marca: null
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    ModeloProvider.createModelo(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.modeloCreate)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

